<template>
    <div class="SyntenyFigure-div">
        <div>
            <h2 style="text-align: center;padding-top: 20px;font-size: 30px;color: #407338">Synteny @ Genome</h2>
        </div>
        <div style="width: 910px;margin: 30px auto 10px auto;">
            <el-form :inline="true" size="small" @submit.native.prevent class="demo-form-inline" style="margin-top: 15px" label-width="150px">
                <el-form-item style="text-align: left" label="query genome">
                    <el-select style="width: 280px;margin-right: 7px" v-model="genome2">
                        <template v-for="genome2 in genome_sheet2">
                            <el-option v-if="genome2.species != 'All'" :key="genome2" :label="genome2.species" :value="genome2.species"></el-option>
                        </template>
                    </el-select>
                </el-form-item>

                <el-form-item style="text-align: left; margin-left: 100px" label="subject genome">
                    <el-select style="width: 280px;margin-right: 7px" v-model="genome1">
                        <template v-for="genome1 in genome_sheet1">
                            <el-option v-if="genome1.species != 'All'" :key="genome1" :label="genome1.species" :value="genome1.species"></el-option>
                        </template>
                    </el-select>
                </el-form-item>
            </el-form>

            <el-form :inline="true" size="small" @submit.native.prevent class="demo-form-inline" style="margin-top: 15px" label-width="150px">
                <el-form-item style="text-align: left" label="example">
                    <el-button type="primary" style="width: 400px;" @click="example456">Brara_Chiifu_V1.5 to Ath_TAIR_V10.1</el-button>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" style="width: 80px; margin-left: 285px" @click="example_help">Help</el-button>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" style="width: 120px; margin-left: 240px" @click="toSearchSyntenyFigureData">SUBMIT</el-button>
                </el-form-item>
            </el-form>    
        </div>
        <div class="SyntenyFigure-options">
            <el-button type="primary" style="width: 120px; margin: -20px auto 0px 983px;" @click="transpose">Transpose</el-button>
            <svg width="1000" height="600" style="margin:0px 99px 25px 99px;border: 2px solid #407338" id="SyntenicFigure_svg" class="svgs"></svg>
        </div>
        <div id="waiting" v-if="isWaiting">
            <img src="../assets/img/waiting.gif" style="height: 200px;width: 200px">
        </div>
    </div>
</template>

<script>
    import * as d3 from 'd3';
    import axios from "axios";
    import {downloadable} from 'd3-downloadable';
    export default {
        name: 'SyntenicFigure',
        data () {
            return {
                genome_sheet1: {},
                genome_sheet2: {},
                genome1: '',
                genome2: '',
                chromosomes: [],
                syntenicGeneLocation: [],
                species: [],
                isWaiting: 0,
                // chromosomes: [
                //     [
                //         ['0', 'Chr1', 'Chr2', 'Chr3', 'Chr4', 'Chr5'],
                //         ['0', '123456', '246743', '456734', '897632', '1235453']
                //     ],
                //     [
                //         ['0', 'A01', 'A02', 'A03', 'A04', 'A05', 'A06'],
                //         ['0', '578542', '1097292', '1809437', '3120802', '4123907', '6754534']
                //     ]
                // ],
                // syntenicGeneLocation: [
                //     ['12345', '34623'],
                //     ['31365', '124315'],
                //     ['53178', '179760'],
                //     ['71092', '346524'],
                //     ['324766', '1465347']
                // ],
            }
        },
        mounted() {
            this.get_genomes_show();
            // this.ScatterPlotInit();
        },
        methods: {
            get_genomes_show() {
                axios({
                    url:'http://39.100.233.196:8001/api/get-species-information/',
                    type: 'json',
                    method: 'get',
                }).then((res)=>{
                    // console.log(res.data);
                    this.genome_sheet1 = res.data
                    this.genome_sheet2 = res.data
                })
            },
            example_help() {
                this.$router.push({path: '../Userguide/'})
            },
            example456() {
                this.genome1 = 'Ath_TAIR_V10.1';
                this.genome2 = 'Brara_Chiifu_V1.5';
                this.toSearchSyntenyFigureData();
            },
            toSearchSyntenyFigureData() {
                this.isWaiting = 1;
                if (this.genome1 == '') {
                    alert("Subject genome can't be empty!")
                    this.isWaiting = 0;
                } else if (this.genome2 == '') {
                    alert("query genome can't be empty!")
                    this.isWaiting = 0;
                } else if (this.genome1 == this.genome2) {
                    alert("Subject genome and query genome can't be equal")
                    this.isWaiting = 0;
                }
                d3.select('svg').selectAll('*').remove();
                const genome1 = this.genome1;
                const genome2 = this.genome2;
                axios({
                    url: 'http://39.100.233.196:8001/api/search-synteny-figure-data/',
                    type: 'json',
                    method: 'get',
                    params: {
                        genome1,
                        genome2
                    }
                }).then((res) => {
                    console.log(res.data);
                    this.chromosomes = res.data[0];
                    // console.log(this.chromosomes)
                    this.syntenicGeneLocation = res.data[1];
                    this.species = [this.genome1, this.genome2];
                    this.ScatterPlotInit();
                })
            },
            transpose() {
                this.isWaiting = 1;
                d3.select('svg').selectAll('*').remove();
                var chromosome_mid = this.chromosomes[1];
                this.chromosomes[1] = this.chromosomes[0];
                this.chromosomes[0] = chromosome_mid;
                // console.log(this.chromosomes)

                var x;
                for (x in this.syntenicGeneLocation) {
                    var syntenicGeneLocation_mid = this.syntenicGeneLocation[x][1];
                    this.syntenicGeneLocation[x][1] = this.syntenicGeneLocation[x][0];
                    this.syntenicGeneLocation[x][0] = syntenicGeneLocation_mid;
                }
                // var syntenicGeneLocation_mid = this.syntenicGeneLocation[1];
                // this.syntenicGeneLocation[1] = this.syntenicGeneLocation[0];
                // this.syntenicGeneLocation[0] = syntenicGeneLocation_mid;

                var species_mid = this.species[1];
                this.species[1] = this.species[0];
                this.species[0] = species_mid;
                this.ScatterPlotInit();
            },
            ScatterPlotInit() {
                var _this = this;

                const svg = d3.select('#SyntenicFigure_svg');
                const width = +svg.attr('width');
                const height = +svg.attr('height');
                const margin = {top: 60, right: 30, bottom: 90, left: 90};
                const innerWidth = width - margin.left - margin.right;                              
                const innerHeight = height - margin.top - margin.bottom;                             // eslint-disable-line no-unused-vars

                var xScale = d3.scaleLinear()                                                        // eslint-disable-line no-unused-vars
                .domain([0, _this.chromosomes[0][1][_this.chromosomes[0][1].length-1]])
                .range([0, innerWidth])

                var yScale = d3.scaleLinear()
                .domain([0, _this.chromosomes[1][1][_this.chromosomes[1][1].length-1]])
                .range([innerHeight, 0])

                var xScale_range_list = [];
                var x;
                for (x in this.chromosomes[0][1]) {
                    xScale_range_list.push(xScale(this.chromosomes[0][1][x]));
                }

                var xScale1 = d3.scaleOrdinal()
                .domain(this.chromosomes[0][0])
                .range(xScale_range_list);

                var yScale_range_list = [];
                var y;
                for (y in this.chromosomes[1][1]) {
                    yScale_range_list.push(yScale(this.chromosomes[1][1][y]));
                }

                var yScale1 = d3.scaleOrdinal()
                .domain(this.chromosomes[1][0])
                .range(yScale_range_list);

                const g = svg.append('g').attr('id', 'maingroup')
                .attr('transform', `translate(${margin.left}, ${margin.top})`);

                const xAxis = d3.axisBottom(xScale1).tickSize(-innerHeight);
                g.append('g')
                .attr('class', 'xAxis')
                .call(xAxis)
                .attr('transform', `translate(${0}, ${innerHeight})`);

                const yAxis = d3.axisLeft(yScale1).tickSize(-innerWidth);
                g.append('g')
                .attr('class', 'yAxis')
                .call(yAxis);

                g.append("text")
                .text(this.species[1])
                .attr("text-anchor", "middle")
                .attr('font-size', '2em')
                .attr('transform', `translate(-${margin.left/2}, ${innerHeight/2}) rotate(-90)`);

                g.append("text")
                .text(this.species[0])
                .attr('text-anchor', 'middle')
                .attr('font-size', '2em')
                .attr('transform', `translate(${innerWidth/2}, ${innerHeight * 1.15})`);

                g.selectAll('.tick line')
                .attr('stroke', '#a4b0be')

                g.selectAll('circle')
                .data(this.syntenicGeneLocation)
                .enter()
                .append('circle')
                .attr('fill', 'black')
                .attr('cx', d => xScale(d[0]))
                .attr('cy', d => yScale(d[1]))
                .attr('r', 0.6);

                d3.selectAll('.tick text')
                .attr('font-size', '1.2em')
                .attr('text-anchor', 'end')
                .attr('transform', 'rotate(-45)');

                var xAxisTexts = d3.selectAll('.xAxis .tick')._groups[0];
                var xAxisText;
                for (xAxisText in xAxisTexts) {
                    // console.log(xAxisTexts[xAxisText].childNodes[1].attributes)
                    if (xAxisTexts[xAxisText].__data__ == '0') {
                        xAxisTexts[xAxisText].childNodes[1].attributes.fill.nodeValue = '#00000000'
                    }
                }

                var yAxisTexts = d3.selectAll('.yAxis .tick')._groups[0];
                var yAxisText;
                for (yAxisText in yAxisTexts) {
                    // console.log(xAxisTexts[xAxisText].childNodes[1].attributes)
                    if (yAxisTexts[yAxisText].__data__ == '0') {
                        yAxisTexts[yAxisText].childNodes[1].attributes.fill.nodeValue = '#00000000'
                    }
                }

                // g.append('text').text('Synteny dotplot figure')
                // .attr('font-size', '2em')
                // .attr('transform', `translate(${innerWidth/2}, -20)`)
                // text-anchor可以调整text的移动的位置，比如下面的middle，可以设置将其参考位置设置为中间
                // .attr('text-anchor', 'middle');

                const zoom = d3.zoom()
                .scaleExtent([1, 100])
                .on('zoom', function() {
                    g.attr('transform', d3.event.transform)
                })

                this.isWaiting = 0;

                svg.call(zoom);

                svg.call(downloadable({
                    width: width,
                    height: height,
                    filename: 'parallel'
                }))
            }
        },
        watch: {
            // 'genome1': {
            //     handler: function (val) {
            //         if (val == this.genome2) {
            //             alert("genome1 can't equal to genome2!")
            //             this.genome1 = ''
            //         }
            //     }
            // },
            // 'genome2': {
            //     handler: function (val) {
            //         if (val == this.genome1) {
            //             alert("genome1 can't equal to genome2!")
            //             this.genome2 = ''
            //         }
            //     }
            // },
        }
    }
</script>

<style>

    .SyntenyFigure-div .el-form-item__label {
        color: #407338;
    }

    .SyntenyFigure-div .el-button {
        background-color: #E1E1E1;
        color: #407338;
        border: #ADADAD;
        font-size: 16px;
    }

    .SyntenyFigure-div .el-button:hover {
        background-color: #E5F1FB;
        color: black;
    }

    .SyntenyFigure-div .el-form-item__content{
        width: 160px;
    }

    .SyntenyFigure-div .el-input{
        width: 280px;
    }

</style>
